// extracted by mini-css-extract-plugin
export default {"root":"I5BSkY"};